import { IOTSimListLookupImpl } from "../data/IOTSimListLookupImpl";
import { IIOTSimListLookupRepository } from "../domain/repositories/IIOTSimListLookupRepository";
import { IOTSimListLookupUseCase } from "../domain/useCases/IOTSimListLookupUseCase";
import { IOTSimListLookupViewModel } from "../presentation/viewModel/IOTSimListLookupViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class IOTSimListLookupInjection extends InjectionModule {
  private static readonly iotSimListLookupRepositoryToken = Symbol(
    "IIOTSimListLookupRepo",
  );
  private static readonly iotSimListLookupUseCaseToken = Symbol(
    "IOTSimListLookupUseCase",
  );
  private static readonly iotSimListLookupViewModelToken = Symbol(
    "IOTSimListLookupViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.iotSimListLookupRepositoryToken,
      useClass: IOTSimListLookupImpl,
    },
    {
      scope: "otherRepo",
      token: this.iotSimListLookupUseCaseToken,
      useClass: IOTSimListLookupUseCase,
    },
    {
      scope: "viewModel",
      token: this.iotSimListLookupViewModelToken,
      useClass: IOTSimListLookupViewModel,
    },
  ];

  static getIOTSimListLookupRepo(): IIOTSimListLookupRepository {
    return this.resolve(this.iotSimListLookupRepositoryToken);
  }

  static getIOTSimListLookupUseCase(): IOTSimListLookupUseCase {
    return this.resolve(this.iotSimListLookupUseCaseToken);
  }
}
